import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type CreateWhatsAppGroupInput = {
    subject: string;
    participants?: string[];
};

export type CreateWhatsAppGroupResponse = {
    groupId: string;
    inviteLink?: string;
};

export const GET_WHATSAPP_GROUPS_QUERY_KEY = (organizationId: string) =>
    ['organization', organizationId, 'whatsappGroups'];

export const useCreateWhatsAppGroup = (organizationId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createWhatsAppGroup', organizationId],
        mutationFn: (body: CreateWhatsAppGroupInput) =>
            apiClient.fetchApi<CreateWhatsAppGroupResponse, CreateWhatsAppGroupInput>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/whatsapp-groups`,
                body,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries(GET_WHATSAPP_GROUPS_QUERY_KEY(organizationId));
        },
    });
};
